import { Box, Button, Grid, styled, Table, TableBody, TableContainer, TableHead, Typography, useTheme } from '@mui/material'
import React from 'react'
import { useCommonStyles } from '../../utils';
import StyledTableRow from '../Common/StyledTableRow';
import StyledTableCell from '../Common/StyledTableCell';
import NoDataFound from '../Common/NoDataFound';

const KeyName = styled('div')(({ theme }) => ({
    fontSize: '16px',
    fontFamily: 'Satoshi-Light',
}));

const Answer = styled('div')(({ theme }) => ({
    fontSize: '16px',
    fontFamily: 'Satoshi-Bold',
}));

const ViewUserRole = ({ setIsOpenViewDrawer, selectedItem }) => {
    // =============== Hooks ===============
    const theme = useTheme();
    const { classes } = useCommonStyles();

    const tempData = [
        {
            module: "Vendor Management",
            permission: "Can View & Edit",
        },
        {
            module: "Vendor Management",
            permission: "Can View & Edit",
        },
        {
            module: "Vendor Management",
            permission: "Can View & Edit",
        },
        {
            module: "Vendor Management",
            permission: "Can View & Edit",
        },
        {
            module: "Vendor Management",
            permission: "Can View & Edit",
        },
        {
            module: "Vendor Management",
            permission: "Can View & Edit",
        },
    ]
    return (
        <>
            <Grid container padding={"30px"} spacing={3}>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Role</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.role || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>User Name</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.userName || "NA"}</Answer>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>email Id</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.email || "NA"}</Answer>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Box sx={{ borderRadius: "26px", border: "1px solid", backgroundColor: theme.palette.bgWhite.main, borderColor: "#c8d3d96e", borderTop: "none" }}>
                        <TableContainer>
                            <Table >
                                <TableHead>
                                    <StyledTableRow isHeader style={{ backgroundColor: "#E9E9E9" }}>
                                        <StyledTableCell>{"Modules"}</StyledTableCell>
                                        <StyledTableCell>{"Permissions"}</StyledTableCell>
                                    </StyledTableRow>
                                </TableHead>
                                <TableBody>
                                    {selectedItem?.permission?.length > 0 ?
                                        selectedItem?.permission?.map((row, index) => (
                                            <React.Fragment key={index}>
                                                <StyledTableRow>
                                                    <StyledTableCell sx={{ borderBottomLeftRadius: index == tempData.length - 1 ? "26px" : "0px" }}> {row.sectionName ? row.sectionName : "NA"}</StyledTableCell>
                                                    <StyledTableCell sx={{ borderBottomRightRadius: index == tempData.length - 1 ? "26px" : "0px" }}>
                                                        {(!row?.view && row?.edit) ? "Edit Only" : (row?.view && !row?.edit) ? "View Only" : (row?.view && row?.edit) ? "Can View & Edit" : "NA"}
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            </React.Fragment>
                                        ))
                                        :
                                        <StyledTableRow>
                                            <StyledTableCell colSpan={12}>
                                                <NoDataFound />
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Grid>
            </Grid>
            <Box display={"flex"} gap={2} padding={"30px"} pt={0}>
                <Button className={classes?.cancelButton} onClick={() => setIsOpenViewDrawer(false)}>Cancel</Button>
            </Box>
        </>
    )
}

export default ViewUserRole